export const CONFIRM = {
  CART_AND_ROUTE: '장바구니에 상품을 담았습니다. 장바구니로 이동하시겠습니까?',
  CART_DELETE: '선택하신 상품을 장바구니에서 삭제하시겠습니까?',
};
